import { render, staticRenderFns } from "./organization-audit-control-detail.vue?vue&type=template&id=db94e856&"
import script from "./organization-audit-control-detail.vue?vue&type=script&lang=js&"
export * from "./organization-audit-control-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports